
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 92 92"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M76.919 13.23v30.929c0 .785-.157 2.826-.157 3.611v.314c-1.099 17.584-13.188 28.417-31.714 28.417a29.328 29.328 0 01-21.666-8.792 28.982 28.982 0 01-7.693-21.352c.628-14.758 13.345-25.591 29.359-25.591a25.308 25.308 0 019.42 1.413v15.072l-.785-.314a15.826 15.826 0 00-7.065-1.256c-5.024-.157-9.577 1.57-12.089 4.553a12.905 12.905 0 00-2.983 8.321 13.22 13.22 0 002.983 8.478 14.994 14.994 0 0012.089 4.553c10.676-.471 13.502-9.106 14.287-14.287.314-2.512.471-7.536.471-8.164V3.605A43.254 43.254 0 0046.461.938 44.98 44.98 0 1076.919 13.23z","fill":"#00d369"}})])
          )
        }
      }
    